import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=5887e821&scoped=true"
import script from "./Demand.vue?vue&type=script&lang=ts"
export * from "./Demand.vue?vue&type=script&lang=ts"
import style0 from "./Demand.vue?vue&type=style&index=0&id=5887e821&prod&lang=css"
import style1 from "./Demand.vue?vue&type=style&index=1&id=5887e821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5887e821",
  null
  
)

export default component.exports